import './spiner.css';

function Spiner() {
  return (
    <div className="spinner">
      <span>
        <svg className="spinner-svg" viewBox="0 0 42 42">
          <g fill="none" transform="translate(3 3)" strokeWidth="3">
            <circle className="circle" cx="18" cy="18" r="18" />

            <path className="segment" d="M36 18c0-9.94-8.06-18-18-18" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </svg>
      </span>
    </div>
  );
}

export default Spiner;
